module.exports = __webpack_public_path__ + "static/hewankesayangan-6fba46a73aa0676fa77a3c01b5e2ac32.png";